var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from '@web/components/ui/Avatar';
export function UserAvatar(_a) {
    var user = _a.user, size = _a.size;
    var attrs = {
        src: user === null || user === void 0 ? void 0 : user.avatar,
        alt: (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.email),
        text: (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.email)
    };
    switch (size) {
        case 'small':
            return (_jsx(Avatar, __assign({ width: 24, height: 24, textClassName: "text-xs" }, attrs)));
        case 'medium':
            return (_jsx(Avatar, __assign({ width: 32, height: 32, textClassName: "text-lg font-medium" }, attrs)));
        case 'large':
            return (_jsx(Avatar, __assign({ width: 40, height: 40, textClassName: "text-lg font-medium" }, attrs)));
        case 'xl':
            return (_jsx(Avatar, __assign({ width: 48, height: 48, textClassName: "text-lg font-medium" }, attrs)));
        case '2xl':
            return (_jsx(Avatar, __assign({ width: 80, height: 80, textClassName: "text-4xl font-medium" }, attrs)));
    }
    return _jsx(Avatar, __assign({}, attrs));
}
export default UserAvatar;
